import { render, staticRenderFns } from "./image-unload.vue?vue&type=template&id=96f91012&"
import script from "./image-unload.vue?vue&type=script&lang=js&"
export * from "./image-unload.vue?vue&type=script&lang=js&"
import style0 from "./image-unload.vue?vue&type=style&index=0&id=96f91012&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports